import styled from 'styled-components'
import { Modal } from 'antd'

export const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    background-color: #e3edf7;
    border-radius: 16px;
  }
  .ant-modal-header {
    background-color: transparent;
    border-bottom: none;
    padding: 24px 24px 16px;
    border-radius: 16px 16px 0 0;
  }
  .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  .ant-modal-close {
    top: 20px;
    right: 20px;
  }
  .ant-modal-body {
    padding: 0 24px 24px;
  }
`

export const SignatureCanvasWrapper = styled.div`
  border: 1px solid #dee2e6 !important;
  border-radius: 5px;
  width: 600px;
  overflow: hidden;
  padding: 5px;
  background-color: #f5f5f5;
  cursor: crosshair;
`

export const ColorPickerWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  margin-bottom: 10px;
`

export const ColorSelected = styled.div`
  width: 55px;
  height: 25px;
  padding: 3px;
  margin-left: 10px;
  border: 1px solid #dee2e6 !important;
  border-radius: 4px;

  span {
    display: block;
    height: 100%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 15px;
  margin-top: 15px;
`
